import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../../base/base-mutation';
import { Rule } from '../../base/mutation-rules';
import { DataType } from '../../../data';
import type { IWidthInfo, ICTTableCol } from '@tencent/slide-sdk-pb-model';
import type { PresentationDataModel } from '../../../model/presentation-data-model';
import type { MaybeError } from '../../base/base-mutation';
import type { IValidSetTableColWidthsMutationData } from '../../base/valid-mutation-data';

export class SetTableColWidthsMutation extends BaseMutation<
    PresentationDataModel,
    IValidSetTableColWidthsMutationData
> {
    public readonly type: MutationType = MutationType.SetTableColWidths;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.shapeId || !this.data.widths) return;

        const { shapeId, widths } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        assert(table, 'table should exist');
        if (!table) return;
        table.store.setTableColWidths(widths);
    }

    public invert(presentation: PresentationDataModel): [IValidSetTableColWidthsMutationData] {
        const { pageId, shapeId } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        assert(table, 'shape should exist');

        const widths: IWidthInfo[] = table?.store.colList.map((tableCol: ICTTableCol, col: number) => ({
            index: col,
            width: tableCol.w ?? 0,
        }));
        return [
            {
                type: MutationType.SetTableColWidths,
                pageId,
                shapeId,
                widths,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId } = this.data;
        return Rule.shape.should.existInPage(presentation, shapeId, pageId);
    }
}
